import { Layout } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { ReactNode, Suspense, useEffect } from 'react';
import siderImg from './../../../assets/static/images/auth-aside.png';
import { COOKIE_KEY } from '@shared/constants';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useActiveWorkspacesQuery } from '@/types/generated/graphql';
import { useSupportChat } from '@shared/hooks/use-support-chat';

interface Props {
  children: ReactNode;
}

export function PublicLayout({ children }: Props) {
  useSupportChat();
  const { data, loading } = useActiveWorkspacesQuery({
    skip: !Cookies.get(COOKIE_KEY.accessToken),
  });
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get(COOKIE_KEY.accessToken);
    if (!token) return;
    const workspaces = data?.activeWorkspaces?.edges ?? [];
    const currentWorkspace = workspaces.find((ws) => ws?.isCurrent) || workspaces[0];
    const hasCompleted = currentWorkspace?.hasCompleted ?? false;
    if (hasCompleted) {
      navigate('/', { replace: true });
    }
  }, [data, loading]);
  return (
    <Layout hasSider>
      <Suspense>
        <Sider width={420} theme="light" className={`bg-gray-100! hidden  lg:block`}>
          <div
            className={`h-full bg-(image) bg-center bg-size bg-no-repeat bg-contain`}
            style={{ backgroundImage: `url(${siderImg})` }}
          ></div>
        </Sider>
        <Layout className="bg-surface! overflow-auto h-dvh">
          <div className="grid place-items-center overflow-auto h-full">{children}</div>
        </Layout>
      </Suspense>
    </Layout>
  );
}
